<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1">
<a id="page_iv">
</a><a id="page_v">For</a></p><a id="page_v">
<p class="ded">David Hartwell</p>
<p class="ded">Page Cuddy</p>
<p class="ded">John Rush</p>
<p class="ded">—they pushed very gently</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Ded.vue?e2c33d30